import type {
  PrintableDocument,
  PrintDocumentType,
  PrintedBusinessIdentity,
  PrintTemplate,
} from '@optiflow/types';

/** The identity the preview shows when the tenant has set none: a made-up store with no logo, legal name or tax number. */
export const SAMPLE_IDENTITY: PrintedBusinessIdentity = {
  source: 'SNAPSHOT',
  displayName: 'OptiFlow Optical',
  legalName: null,
  taxRegistrationNumber: null,
  logo: null,
};

/** A QR drawn once by the same server renderer as every real document, encoding only the words below: it opens nothing, names no document and holds no token. */
export const SAMPLE_QR_TEXT = 'OPTIFLOW PRINT PREVIEW - SAMPLE ONLY';
const SAMPLE_QR_SVG =
  '<svg viewBox="0 0 74 74" xmlns="http://www.w3.org/2000/svg"><rect width="100%" height="100%" fill="#FFFFFF" /><path d="M8 66L22 66L22 52L8 52ZM26 66L30 66L30 64L26 64ZM34 66L42 66L42 64L38 64L38 62L40 62L40 60L34 60L34 62L32 62L32 60L34 60L34 58L40 58L40 56L36 56L36 54L38 54L38 52L40 52L40 50L38 50L38 48L42 48L42 44L44 44L44 48L42 48L42 52L44 52L44 50L46 50L46 52L48 52L48 56L46 56L46 58L48 58L48 60L50 60L50 58L52 58L52 62L56 62L56 64L58 64L58 66L60 66L60 64L62 64L62 62L64 62L64 64L62 64L62 66L66 66L66 60L64 60L64 58L66 58L66 54L60 54L60 56L62 56L62 60L60 60L60 62L58 62L58 58L60 58L60 56L58 56L58 54L60 54L60 50L58 50L58 44L56 44L56 48L52 48L52 46L50 46L50 44L46 44L46 42L50 42L50 40L46 40L46 36L48 36L48 34L44 34L44 36L42 36L42 38L44 38L44 40L42 40L42 38L40 38L40 40L34 40L34 38L38 38L38 36L42 36L42 34L38 34L38 32L32 32L32 34L34 34L34 36L30 36L30 40L32 40L32 42L34 42L34 44L38 44L38 42L40 42L40 46L36 46L36 48L34 48L34 50L36 50L36 52L34 52L34 56L32 56L32 58L30 58L30 60L28 60L28 62L30 62L30 64L34 64ZM44 66L48 66L48 64L44 64ZM10 64L10 54L20 54L20 64ZM24 64L26 64L26 60L24 60ZM42 64L44 64L44 62L42 62ZM48 64L52 64L52 62L48 62ZM12 62L18 62L18 56L12 56ZM44 62L48 62L48 60L44 60ZM42 60L44 60L44 54L40 54L40 56L42 56ZM54 60L54 58L56 58L56 60ZM26 58L30 58L30 56L32 56L32 52L34 52L34 50L32 50L32 48L30 48L30 54L28 54L28 52L26 52ZM50 56L50 50L56 50L56 56ZM52 54L54 54L54 52L52 52ZM24 52L26 52L26 50L24 50ZM64 52L66 52L66 44L64 44L64 48L60 48L60 50L64 50ZM8 50L12 50L12 48L8 48ZM14 50L22 50L22 48L20 48L20 46L18 46L18 48L16 48L16 46L18 46L18 44L20 44L20 42L18 42L18 40L20 40L20 38L22 38L22 36L20 36L20 34L22 34L22 32L14 32L14 34L10 34L10 36L14 36L14 38L12 38L12 44L14 44L14 42L16 42L16 44L14 44ZM22 48L24 48L24 46L22 46ZM26 48L30 48L30 44L32 44L32 42L26 42L26 36L24 36L24 42L22 42L22 44L24 44L24 46L26 46ZM8 46L12 46L12 44L8 44ZM20 46L22 46L22 44L20 44ZM32 46L34 46L34 44L32 44ZM50 44L56 44L56 42L58 42L58 40L54 40L54 42L50 42ZM60 44L62 44L62 40L60 40ZM20 42L22 42L22 40L20 40ZM8 40L10 40L10 36L8 36ZM58 40L60 40L60 36L58 36ZM64 40L66 40L66 32L64 32L64 34L60 34L60 36L64 36ZM16 38L16 36L18 36L18 38ZM48 38L50 38L50 36L48 36ZM52 38L56 38L56 36L58 36L58 30L62 30L62 32L64 32L64 30L66 30L66 28L64 28L64 26L62 26L62 28L56 28L56 30L54 30L54 28L52 28ZM26 36L30 36L30 30L28 30L28 34L26 34ZM24 34L26 34L26 32L24 32ZM42 34L44 34L44 22L42 22L42 20L44 20L44 22L46 22L46 14L48 14L48 22L50 22L50 8L46 8L46 10L48 10L48 12L46 12L46 10L44 10L44 8L42 8L42 10L40 10L40 12L36 12L36 14L38 14L38 16L36 16L36 18L34 18L34 20L36 20L36 24L38 24L38 20L40 20L40 24L42 24L42 26L40 26L40 24L38 24L38 26L36 26L36 28L38 28L38 32L42 32ZM48 34L50 34L50 24L48 24L48 22L46 22L46 26L48 26L48 30L46 30L46 32L48 32ZM8 32L12 32L12 26L14 26L14 24L10 24L10 26L8 26L8 28L10 28L10 30L8 30ZM22 32L24 32L24 30L22 30ZM14 30L22 30L22 28L20 28L20 26L18 26L18 28L16 28L16 26L14 26ZM26 30L28 30L28 28L26 28ZM30 30L32 30L32 28L34 28L34 26L36 26L36 24L32 24L32 22L30 22L30 24L28 24L28 22L26 22L26 20L28 20L28 18L30 18L30 20L32 20L32 16L30 16L30 10L28 10L28 16L26 16L26 18L24 18L24 24L26 24L26 26L30 26ZM40 30L40 28L42 28L42 30ZM22 28L24 28L24 26L22 26ZM54 28L56 28L56 24L52 24L52 26L54 26ZM20 26L22 26L22 24L20 24ZM58 26L60 26L60 24L58 24ZM8 22L22 22L22 8L8 8ZM28 22L30 22L30 20L28 20ZM32 22L34 22L34 20L32 20ZM52 22L66 22L66 8L52 8ZM10 20L10 10L20 10L20 20ZM54 20L54 10L64 10L64 20ZM12 18L18 18L18 12L12 12ZM40 18L40 14L42 14L42 12L44 12L44 18ZM56 18L62 18L62 12L56 12ZM24 16L26 16L26 14L24 14ZM32 16L34 16L34 10L36 10L36 8L32 8ZM26 10L28 10L28 8L26 8ZM38 10L40 10L40 8L38 8Z" fill-rule="evenodd" fill="#000000" /></svg>';

/**
 * Fixed, made-up sale for the settings preview.
 *
 * The preview never reads a customer, an order, an invoice or a verification token: everything it
 * shows is this constant, laid out by the same renderer a real print uses.
 */
export function sampleDocument(
  documentType: PrintDocumentType,
  template: PrintTemplate,
  identity: PrintedBusinessIdentity = SAMPLE_IDENTITY,
): PrintableDocument {
  return {
    kind: documentType,
    identity,
    tenantName: identity.displayName,
    branchName: 'Main Branch',
    branchPhone: '+20 100 000 0000',
    branchAddress: '12 Sample Street, Cairo',
    reference: documentType === 'INVOICE' ? 'INV-000123' : 'SO-000123',
    issuedAt: '2026-09-24',
    customerName: null,
    cashierName: 'Sample Cashier',
    currencyCode: 'EGP',
    lines: [
      {
        description: 'Aviator Classic — Gold / 58',
        sku: 'SAMPLE-FRAME-58',
        quantity: 1,
        unitPriceMinor: 250_000,
        discountMinor: 25_000,
        taxMinor: 27_632,
        totalMinor: 225_000,
      },
      {
        description: 'Lens cleaning kit',
        sku: 'SAMPLE-KIT-01',
        quantity: 2,
        unitPriceMinor: 15_000,
        discountMinor: 0,
        taxMinor: 3_684,
        totalMinor: 30_000,
      },
    ],
    subtotalMinor: 223_684,
    discountMinor: 25_000,
    taxMinor: 31_316,
    totalMinor: 255_000,
    payments: [{ method: 'CASH', amountMinor: 200_000 }],
    paidMinor: 200_000,
    outstandingMinor: 55_000,
    verification: { url: SAMPLE_QR_TEXT, qrSvg: SAMPLE_QR_SVG },
    template,
  };
}
